import React ,{useState} from "react";
import Banner from "./Banner/Banner";
import LiveAuctions from "./LiveAcutions/LiveAcutions";
import NavLayout from "../../GlobalComponents/NavLayout/NavLayout";
import Footer from "../../GlobalComponents/Footer/Footer";
import { publicNav } from "../../utils/navItems";
import ConnectButton from "../../GlobalComponents/ConnectButton/ConnectButton";
import { buyNow } from "./interface";
import { useConnectModal, useAccountModal, useChainModal } from "@rainbow-me/rainbowkit";
const NftDetails = () => {
  const [refreshit, setrefreshit] = useState(false);
  const { openConnectModal } = useConnectModal();
  const [address, setAddress] = useState("");
  const handleBuyClick = async () =>{
    console.log("buy click");
    try {
      await buyNow(0, 2.87, openConnectModal);
      //await bid(value)
      setrefreshit(!refreshit);

    } catch (e) {
      console.log(e);
    }
  }
  return (
    <div>
      <NavLayout
        navItems={publicNav}
        setAddress={setAddress}
        bold={true}
        buttons={
          <div className="button-container">
            <ConnectButton></ConnectButton>
          </div>
        }
      ></NavLayout>

      <div className="container pt-[25px] md:pt-[59px]">
        <div className="text-center">
          <h2 className="text-[30px] md:text-[48px] font-bold leading-[30px] md:leading-[57px]">
            {" "}
            <span className="text-main-green">The R34P</span> Platinum NFT
          </h2>
          <p className="text-res-ls leading-[28px] text-[#8A8AA0]">
            <span>Home</span>
            <span className="mx-[12px]">/</span>
            <span>NFTs</span>
            <span className="ml-[34px] mr-[12px]">/</span>
            <span className="text-white">R34P Platinum</span>
          </p>
        </div>
      </div>
      <Banner buyClick={handleBuyClick}></Banner>
      <LiveAuctions></LiveAuctions>
      <div className="mt-10">
        <Footer></Footer>
      </div>
    </div>
  );
};

export default NftDetails;
